import React from "react";
import { Grid, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const RecipientIncomingMailLink = ({
  customSummary,
  loading,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);

  const isOnlyRecipient =
    (!currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming)) ??
    true;

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        textAlign: "center",
        alignItems: "center",
      }}
    >
      {/* {
      !!state.summary?.incomingMailsForRecipient && 
        state.summary.incomingMailsForRecipient === 0 && ( */}

      {loading ? (
        <Skeleton
          variant="rounded"
          width={"70%"}
          style={{ marginBottom: "2px" }}
        />
      ) : (
        <>
          {isOnlyRecipient ? (
            <Grid>
              {customSummary.incomingMailsForRecipient > 0 ? (
                <Grid
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    color: theme.palette.primary.main,
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <Typography style={{ fontSize: "20px", color: theme.palette.primary.light }}>{`${t(
                    `${tRP}.you_have_received`
                  )}`}</Typography>
                  <Grid
                    style={{
                      display: "flex",
                      color: theme.palette.primary.main,
                      justifyContent: "center",
                      alignItems: "end",
                      gap: "5px",
                    }}
                  >
                    <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>
                      {customSummary?.incomingMailsForRecipient}
                    </Typography>
                    <Typography
                      style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}
                    >{`${t(`${tRP}.incoming`)}`}</Typography>
                  </Grid>
                </Grid>
              ) : (
                <Grid
                  style={{
                    color: theme.palette.primary.main,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography style={{ fontSize: "20px" }}>{`${t(`${tRP}.no_incoming_mails`)}`}</Typography>
                  <Typography style={{ alignSelf: "end" }}>{`${t(`${tRP}.overview`)}`}</Typography>
                </Grid>
              )}
            </Grid>
          ) : customSummary.incomingMailsForRecipient > 0 ? (
            <Grid style={{ marginTop: "5px" }}>
              <Typography style={{ fontSize: "20px", color: theme.palette.primary.light }}>{`${t(
                `${tRP}.received`
              )}`}</Typography>
              <Grid
                style={{
                  display: "flex",
                  color: theme.palette.primary.main,
                  justifyContent: "center",
                  alignItems: "end",
                  gap: "5px",
                }}
              >
                <Typography style={{ fontSize: "16px", lineHeight: "14px" }}>
                  {customSummary?.incomingMailsForRecipient}
                </Typography>
                <Typography style={{ fontSize: "16px", lineHeight: "14px", color: theme.palette.text.primary }}>{`${t(
                  `${tRP}.incoming`
                )}`}</Typography>
              </Grid>
            </Grid>
          ) : (
            <>{""}</>
          )}
        </>
      )}

      {/* )} */}

      {/* {state.summary?.lastUpdateForRecipient && (
        <Typography>Last update : {intlFormatDateShort(state.summary.lastUpdateForRecipient)}</Typography>
      )} */}
    </Grid>
  );
};
export default RecipientIncomingMailLink;
